<template lang="pug">
  .b2b-page-newusercif
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('users.createuser.datauser.title', { username: modifyUserSession.username } ) }}
      ods-form(
        ref='userForm',
        :rules='rulesUserForm',
        :model='userForm',
        label-width='14rem',
        label-position='top',
        size='mini')
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              :label='$t("users.createuser.party.partyTaxIdentificationNumber")',
              prop='partyTaxIdentificationNumber')
              ods-input(v-model='userForm.partyTaxIdentificationNumber')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          size='large'
          @click='goDataUser("userForm")')
          | {{ $t('buttons.btnNext') }}
        ods-button(
          ref='buttonClear',
          size='large'
          type='neutral',
          @click='goClear')
          | {{ $t('buttons.btnClear') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newusercif',
  mixins: [Utils],
  data () {
    return {
      userForm: {},
      rulesUserForm: {
        partyTaxIdentificationNumber: [
          {
            max: 50,
            message: this.$t('validations.maxlenght', { maxlenght: 50 }),
            trigger: 'change'
          },
          {
            required: true,
            message: this.$t('validations.required', {
              field: this.$t('users.createuser.party.partyTaxIdentificationNumber')
            }),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters(['modifyUserSession'])
  },

  methods: {
    ...mapActions([
      'validatePartyCif'
    ]),

    goDataUser (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            // Si no valida el CIF sale por la excepción y no redirige
            await this.validatePartyCif({
              partyTax: this.userForm.partyTaxIdentificationNumber
            })
            this.modifyUserSession.partyTaxIdentificationNumber = this.userForm.partyTaxIdentificationNumber
            // Emitimos el evento para pasar a líneas de factura en STEPS
            this.$emit('update', 1)
          } catch (error) {
            this.getNotificationErrorMessage(error)
          }
        } else {
          return false
        }
      })
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    },

    goClear () {
      this.$refs.buttonClear.$el.blur()
      this.userForm.partyTaxIdentificationNumber = ''
    }

  },
  async created () {
    console.log('B2bNewUserCif', this.modifyUserSession)
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-newusercif {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module{
    &__header{
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info{
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body{
      padding: 32px;
      .info{
        padding-bottom: 32px;
      }

      .subtitle{
        margin-top: 40px;
        font-size: 14px;
        font-weight: 500;
        text-transform: uppercase;
      }
    }
  }

  .form-actions{
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button{
      float: right;
    }
  }

  .collapse{
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button{
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
